import React, { Component } from 'react';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap'
import { SideBar } from '../../components/CustomSidebar';
import Trivia from './trivia'
import OpenQueries from './openQueries'
export default class Engage extends Component {
    constructor(props) {
        super(props);
        
        this.Trivia = Trivia.bind(this)
        this.OpenQueries = OpenQueries.bind(this)
    }
    
    render() {
        return (
            <Container className={"flex-container-center pt-2 pb-2 d-sm-flex flex-column"} fluid>
                <Row className="gs-inner-container right-border-radius flex-fill scrollable">
                    <SideBar />
                    <Col className="p-0 m-2 ">

                        <Tabs defaultActiveKey="Trivia" id="uncontrolled-engageTabs">
                            <Tab eventKey="OpenQueries" title="Open Queries">
                                <OpenQueries/>
                            </Tab>
                            <Tab eventKey="Trivia" title="Trivia">
                                <Trivia/>
                            </Tab>
                        </Tabs>

                    </Col>
                </Row>
            </Container>
        )
    }
}